export default {
    teacherLicenses:       { method: 'get',    url: 'teacher_licenses' },
    createTeacherLicense:  { method: 'post',   url: 'teacher_licenses'},
    updateTeacherLicense:  { method: 'put',    url: 'teacher_licenses/{id}'},
    deleteTeacherLicense:  { method: 'delete', url: 'teacher_licenses/{id}'}
}